import { CreateSvg } from "../Create/Svg";

export async function UpdateSvg_MDF() {
  const result = await CreateSvg(true);
  return result;
}
